import React from "react";
import { FixedSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";

export interface LocationsInfiniteLoaderProps {
  hasNextPage: boolean;
  isNextPageLoading: boolean;
  items: React.ReactChildren[];
  loadNextPage: () => null;
  itemSize: number;
  maxMenuHeight: number;
}

export const LocationsInfiniteLoader = ({
  hasNextPage,
  isNextPageLoading,
  items,
  loadNextPage,
  itemSize,
  maxMenuHeight,
}: LocationsInfiniteLoaderProps) => {
  const itemCount = hasNextPage ? items.length + 1 : items.length;
  const loadMoreItems = isNextPageLoading ? () => null : loadNextPage;
  const isItemLoaded = (index: number) => !hasNextPage || index < items.length;

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={loadMoreItems}
    >
      {({ onItemsRendered, ref }) => (
        <List
          itemCount={itemCount}
          itemSize={itemSize}
          onItemsRendered={onItemsRendered}
          ref={ref}
          height={maxMenuHeight}
          width="100%"
        >
          {({ index, style }: { index: number; style: React.CSSProperties }) => (
            <div style={style}>
              {items[index] || <span>Loading...</span>}
            </div>
          )}
        </List>
      )}
    </InfiniteLoader>
  );
};
